import React, {Component} from "react";
import { Navigate } from 'react-router-dom';
class NavigateWithSearch extends Component {

    constructor(props) {
        super(props);
    }


    render() {
        const [path, queryString] = this.props.path.split('?');

        if (queryString) {
            return <Navigate to={{ pathname: path, search: queryString}} />
        } else {
            return <Navigate to={{ pathname: path }} />
        }

    }
}

export default NavigateWithSearch;